import axios from 'axios'
import store from '../store' // 导入store
// 测试服
const VUE_APP_BASE_API = 'https://yufabu.saizhuge.net/api/'
// 正式服
const VUE_APP_BASE_API_PRO = 'https://www.bykjy.com/api/'

// 创建axios实例
const service = axios.create({
  baseURL: VUE_APP_BASE_API_PRO, // API基础路径
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从store中获取token
    const token = store.getters.getToken

    // 不为特定接口添加token
    const noTokenUrls = ['/v1/5d5fa8984f0c2'] // 添加需要排除的接口URL
    if (token && !noTokenUrls.includes(config.url)) {
      config.headers['user-token'] = `${token}`
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 可以根据后端返回的状态码进行统一处理
    if (res.code != 1) {
      // 可以在这里添加错误提示，如弹窗等
      return Promise.reject(res.msg || '请求失败')
    } else {
      return res.data
    }
  },
  error => {
    console.error('响应错误:', error)
    // 可以根据错误状态码进行不同处理
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 未授权，跳转到登录页并清除token
          store.dispatch('removeToken')
          router.push('/login')
          break
        case 403:
          console.error('拒绝访问')
          break
        case 404:
          console.error('请求地址不存在')
          break
        case 500:
          console.error('服务器错误')
          break
        default:
          console.error('请求失败')
      }
    }
    return Promise.reject(error)
  }
)

export default service